import useAppSelector from '../../../hooks/useAppSelector';
import ProductMixAndMatchList from './ProductMixAndMatchList';
import './ProductMixAndMatch.less';
import useAppDispatch from '../../../hooks/useAppDispatch';
import Loader from '../../loader/Loader';
import MainFeatureError from '../common/MainFeatureError';
import { useTranslation } from '../../../hooks/useTranslation';
import { dispatchEvent } from '../../../services/EventService';

const ProductMixAndMatch = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const mainFeatureItem = useAppSelector(
        state => state.featureState.mainFeatureItem
    );

    if (mainFeatureItem?.featureType !== 'product-mix-and-match') {
        return null;
    }
    const { groups, mixAndMatchWithProducts, loadingStatus } = mainFeatureItem;
    return (
        <div className={`bri-ProductMixAndMatch`}>
            <div className={`bri-ProductMixAndMatch-body bri-SlimScroll`}>
                {loadingStatus === 'success' && (
                    <ProductMixAndMatchList
                        fixedProducts={mixAndMatchWithProducts}
                        groups={groups}
                        onAddToCart={products => {
                            if (products.length === 1) {
                                void dispatch.featureState.startFeature({
                                    featureType: 'product-detail',
                                    productId: products[0].productId,
                                    source: 'brilliant'
                                });
                            } else {
                                void dispatch.featureState.startFeature({
                                    featureType:
                                        'product-multi-variant-add-to-cart',
                                    products
                                });
                                dispatchEvent({
                                    type: 'bri.open_add_many_products_to_cart',
                                    isInteraction: true,
                                    source: 'web',
                                    productIds: products.map(
                                        product => product.productId
                                    )
                                });
                            }
                        }}
                    />
                )}
                {loadingStatus === 'loading' && (
                    <Loader
                        title={t('PRODUCT_MIX_AND_MATCH_LOADING_TITLE')}
                        subtitle={t('PRODUCT_MIX_AND_MATCH_LOADING_SUBTITLE')}
                    />
                )}
                {loadingStatus === 'error' && (
                    <MainFeatureError
                        onRetryClick={() => {
                            void dispatch.featureState.startFeature({
                                featureType: 'product-mix-and-match',
                                productId:
                                    mainFeatureItem.mixAndMatchWithProductIds[0]
                            });
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default ProductMixAndMatch;
